import React, { useEffect, useRef, useState } from "react";
import classnames from "classnames";
import BranchLink from "web/react/components/branch-link/branch-link";
import { RawBranchLink } from "web/script/utils/branch-io";
import { gettext } from "web/script/modules/django-i18n";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import screen1 from "img/app-page/screen1.png";
import screen2 from "img/app-page/screen2.png";
import screen3 from "img/app-page/screen3.png";
import styles from "./styles.css";

let screenChangeInterval: NodeJS.Timeout;

export default function SearchAndCompareComponent(): JSX.Element {
    const [currentScreen, setCurrentScreen] = useState(0);
    const filledBarRef = useRef<HTMLDivElement>(null);
    const ofThree = " / 3";
    const branchLink = RawBranchLink.AppTeaser;

    function resetAnimation(): void {
        const filledBar = filledBarRef?.current;
        if (filledBar) {
            filledBar.classList.remove(styles.filledBarAnimation);
            setTimeout(() => {
                filledBar.classList.add(styles.filledBarAnimation);
            }, 100);
        }
    }

    function setScreenChangeInterval(): void {
        screenChangeInterval = setInterval(() => {
            resetAnimation();
            const nextScreen = currentScreen < 2 ? currentScreen + 1 : 0;
            setCurrentScreen(nextScreen);
        }, 6000);
    }

    function changeScreen(nextInterval): void {
        clearInterval(screenChangeInterval);
        resetAnimation();
        setCurrentScreen(nextInterval);
        setScreenChangeInterval();
    }

    function nextScreen(): void {
        changeScreen(currentScreen < 2 ? currentScreen + 1 : 0);
    }

    function prevScreen(): void {
        changeScreen(currentScreen > 0 ? currentScreen - 1 : 2);
    }

    useEffect(() => {
        setScreenChangeInterval();
        return (): void => {
            if (screenChangeInterval) {
                clearInterval(screenChangeInterval);
            }
        };
    });

    return (
        <div className={styles.searchAndCompare}>
            <div
                className={classnames({
                    [styles.screenText]: true,
                    [styles.multilineText]: currentScreen === 1,
                })}
            >
                {currentScreen === 0 && (
                    <h2 className={styles.text1}>{gettext("app_landing.value_search.title")}</h2>
                )}
                {currentScreen === 1 && (
                    <h2 className={styles.text2}>{gettext("app_landing.value_discover.title")}</h2>
                )}
                {currentScreen === 2 && (
                    <h2 className={styles.text3}>{gettext("app_landing.value_save.title")}</h2>
                )}
            </div>
            <div className={styles.phone}>
                <div className={styles.phoneNotch} />
                <div className={styles.phoneBackground} />
                <BranchLink
                    branchLink={branchLink}
                    eventLabel={"screen_web_to_app_download"}
                    title={"screen_web_to_app_download"}
                >
                    <span>
                        {currentScreen === 0 && (
                            <img
                                src={screen1}
                                className={styles.phoneScreen}
                                alt="phone-background"
                            />
                        )}
                        {currentScreen === 1 && (
                            <img
                                src={screen2}
                                className={styles.phoneScreen}
                                alt="phone-background"
                            />
                        )}
                        {currentScreen === 2 && (
                            <img
                                src={screen3}
                                className={styles.phoneScreen}
                                alt="phone-background"
                            />
                        )}
                    </span>
                </BranchLink>
            </div>
            <div className={styles.stateControls}>
                <div className={styles.loadingBar}>
                    <div
                        ref={filledBarRef}
                        className={classnames(styles.filledBar, styles.filledBarAnimation)}
                    />
                </div>
                <div className={styles.screenNumber}>
                    {currentScreen + 1}
                    {ofThree}
                </div>
                <span className={styles.arrowCircle} onClick={nextScreen}>
                    <SVGIcon className={styles.arrowRight} name={"arrow-right"} />
                </span>
                <span className={styles.arrowCircle} onClick={prevScreen}>
                    <SVGIcon className={styles.arrowLeft} name={"arrow-right"} />
                </span>
            </div>
        </div>
    );
}
